<template>
    <div class="ml-2">
        <button type="button" ref="button" id="button" aria-describedby="tooltip" class="bg-teal text-white rounded-full font-bold w-5 h-5 text-base">?</button>
        <div id="tooltip" role="tooltip" ref="tooltip" class="normal-case text-sm  bg-teal-lightest text-black font-normal p-4 rounded z-30 c--copy max-w-xl invisible opacity-0 transition-opacity absolute">
            <p class="text-sm">Copy and paste actual YouTube URL, not the share / embed code.</p>
        </div>
    </div>
</template>

<script>
import { createPopper } from '@popperjs/core';

export default {
    data() {
        return {
            copied: false
        }
    },
    props: [
        'link'
    ],
    mounted: function() {
        const button = this.$refs.button;
        const tooltip = this.$refs.tooltip;

        const popperInstance = createPopper(button, tooltip, {
            placement: 'right',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8], // [skidding, distance]
                    },
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['left', 'bottom'],
                    },
                },
            ],
        });

        function show() {
            tooltip.classList.remove('invisible', 'opacity-0');
            tooltip.classList.add('visible', 'opacity-100');

            // Enable the event listeners
            popperInstance.setOptions((options) => ({
                ...options,
                modifiers: [
                    ...options.modifiers,
                    { name: 'eventListeners', enabled: true },
                ],
            }));

            // Update its position
            popperInstance.update();
        }

        function hide() {
            tooltip.classList.add('invisible', 'opacity-0');
            tooltip.classList.remove('visible', 'opacity-100');

            // Disable the event listeners
            popperInstance.setOptions((options) => ({
                ...options,
                modifiers: [
                    ...options.modifiers,
                    { name: 'eventListeners', enabled: false },
                ],
            }));
        }

        const showEvents = ['mouseenter', 'focus'];
        const hideEvents = ['mouseleave', 'blur'];

        showEvents.forEach((event) => {
            button.addEventListener(event, show);
        });

        hideEvents.forEach((event) => {
            button.addEventListener(event, hide);
        });
    },
}
</script>

<style>
#tooltip[data-show] {
    visibility: visible;
    opacity: 1;
}
</style>